const branchs = [
    {
        name: "Sukhumvit 33",
        name_th: "สุขุมวิท 33",
        distance: "3.0 km",
        latlng: [13.73204799, 100.56762289],
        address: "595 Sukhumvit Rd",
        subDistrict: "North Khlong Ton",
        district: "Vadhana",
        address_th: "595 ถนนสุขุมวิท แขวงคลองตันเหนือ เขตวัฒนา",
        province: "Bangkok",
        province_th: "กรุงเทพมหานคร",
        postcode: "10110",
        phoneNumber: "02-502-7351",
        active: false,
        location_url:
            "https://www.google.co.th/maps/place/Villa+Market+-+Sukhumvit+33,+%E0%B8%96%E0%B8%99%E0%B8%99+%E0%B8%AA%E0%B8%B8%E0%B8%82%E0%B8%B8%E0%B8%A1%E0%B8%A7%E0%B8%B4%E0%B8%97+%E0%B9%81%E0%B8%82%E0%B8%A7%E0%B8%87+%E0%B8%84%E0%B8%A5%E0%B8%AD%E0%B8%87%E0%B8%95%E0%B8%B1%E0%B8%99%E0%B9%80%E0%B8%AB%E0%B8%99%E0%B8%B7%E0%B8%AD+Bangkok,+%E0%B8%81%E0%B8%A3%E0%B8%B8%E0%B8%87%E0%B9%80%E0%B8%97%E0%B8%9E%E0%B8%A1%E0%B8%AB%E0%B8%B2%E0%B8%99%E0%B8%84%E0%B8%A3/@13.73457,100.5798123,17z/data=!4m5!3m4!1s0x30e29f0213378137:0x19a1ece8c2a0dd2f!8m2!3d13.732087!4d100.567631",
        code: "1000",
        online: true,
        hub: "1000",
    },
    {
        name: "Aree",
        name_th: "อารีย์",
        distance: "3.0 km",
        latlng: [13.780088, 100.545136],
        address: "356 Phaholyothin Rd., Samsean-Nai, Payathai",
        subDistrict: "-",
        district: "-",
        address_th: "356 ถนนพหลโยธิน แขวงสามเสนใน เขตพญาไท",
        province: "Bangkok",
        province_th: "กรุงเทพมหานคร",
        postcode: "10400",
        phoneNumber: "02-502-7358",
        active: false,
        location_url:
            "https://www.google.co.th/maps/place/Villa+Market+-+Aree/@13.7800514,100.5429267,17z/data=!3m1!4b1!4m5!3m4!1s0x30e29c195d12bf95:0x28ecc5965220c7f4!8m2!3d13.7800514!4d100.5451154",
        code: "1014",
        online: true,
        hub: "1014",
    },
    {
        name: "Bangna Littlewalk",
        name_th: "บางนา ลิตเติ้ลวอล์ค",
        distance: "3.0 km",
        latlng: [13.668328, 100.639645],
        address: "769 769/3 soi Bang Na-Trad 42 Bang Na, Bangkok 10260",
        subDistrict: "-",
        district: "-",
        address_th:
            "769 769/3 ซอย บางนา-ตราด 42 แขวง บางนา เขตบางนา กรุงเทพมหานคร ",
        province: "Bangkok",
        province_th: "กรุงเทพมหานคร",
        postcode: "10260",
        phoneNumber: "02-502-7379",
        active: true,
        location_url:
            "https://www.google.com/maps/place/Villa+Market+-+Little+Walk+Bang+Na/@13.6801461,100.6155985,12.99z/data=!4m9!1m2!2m1!1z4Lit4Lij4Liq4Liq4Lif4LiX4Lif4Lie4Liy4Liz4LiwIOC4quC4o-C4sOC4sOC4s-C4quC4s-C5hOC4n-C4quC4sg!3m5!1s0x311d5fe97828b2ad:0xacbb3d59e9b83a74!8m2!3d13.6680296!4d100.6395304!15sCkPguK3guKPguKrguKrguJ_guJfguJ_guJ7guLLguLPguLAg4Liq4Lij4Liw4Liw4Liz4Liq4Liz4LmE4Lif4Liq4LiyWk8iTeC4reC4oyDguKog4LiqIOC4nyDguJcg4LifIOC4nuC4suC4s-C4sCDguKog4Lij4Liw4Liw4LizIOC4quC4syDguYTguJ8g4Liq4LiykgELc3VwZXJtYXJrZXQ",
        code: "1044",
        online: true,
        hub: "1044",
    },
    {
        name: "Chaengwatthana",
        name_th: "แจ้งวัฒนะ",
        distance: "3.0 km",
        latlng: [13.894702, 100.558189],
        address: "104/34 Moo 1, Chaengwattana  Rd., Laksi",
        subDistrict: "-",
        district: "-",
        address_th: "104/34 หมู่ที่ 1 ถนนแจ้งวัฒนะ แขวงทุ่งสองห้อง เขตหลักสี่",
        province: "Bangkok",
        province_th: "กรุงเทพมหานคร",
        postcode: "10210",
        phoneNumber: "02-502-7361",
        active: false,
        location_url:
            "https://www.google.co.th/maps/place/Villa+Market+-+Chaengwattana/@13.8950009,100.55579,17z/data=!3m1!4b1!4m5!3m4!1s0x30e283160c22da9b:0xc5e09cae954634a3!8m2!3d13.8950009!4d100.5579787",
        code: "1017",
        online: true,
        hub: "1017",
    },
    // {
    //     name: "Grand Canal",
    //     name_th: "แกรนด์ คาแนล",
    //     distance: "3.0 km",
    //     latlng: [13.881267, 100.550592],
    //     address: "20/492 Moo 9, Pracha Chuen Rd, Pakret",
    //     subDistrict: "-",
    //     district: "Pak Kret",
    //     address_th: "20/429 หมู่ที่ 9 ถนนประชาชื่น อำเภอปากเกร็ด",
    //     province: "Nonthaburi",
    //     province_th: "นนทบุรี",
    //     postcode: "11120",
    //     phoneNumber: "02-502-7357",
    //     active: false,
    //     location_url: "https://www.google.com/maps/place/Talat+Phlu,+Thon+Buri,+Bangkok+10600/@13.7146207,100.476517,229m/data=!3m1!1e3!4m5!3m4!1s0x30e2985d2e50261d:0x40100b25de28b50!8m2!3d13.7184591!4d100.4747843",
    //     code: "1012",
    //     online: true,
    //     hub: "1012",
    // },
    {
        name: "K-Village (Sukhumvit 26)",
        name_th: "K-Village (สุขุทวิท 26)",
        distance: "3.0 km",
        latlng: [13.720521, 100.569057],
        address: "93,95 Soi Sukumvit 26, Sukumvit Rd. Klongtoei,",
        subDistrict: "-",
        district: "-",
        address_th: "93, 95 ซอยสุขุมวิท 26 ถนนสุขุมวิท แขวงคลองตัน เขตคลองเตย",
        province: "Bangkok",
        province_th: "กรุงเทพมหานคร",
        postcode: "10110",
        phoneNumber: "02-502-7369",
        active: false,
        location_url:
            "https://www.google.co.th/maps/place/Villa+Market+-+K+Village/@13.720198,100.5671662,17z/data=!3m1!4b1!4m5!3m4!1s0x30e29f08b35be46d:0xaf429f7404e07d2d!8m2!3d13.720198!4d100.5693549",
        code: "1030",
        online: true,
        hub: "1030",
    },
    {
        name: "Kaset-Nawamin",
        name_th: "เกษตร-นวมินทร์",
        distance: "3.0 km",
        latlng: [13.834663, 100.610776],
        address: "291 Prasertmanukij Rd.",
        subDistrict: "-",
        district: "Ladprao",
        address_th: "291 ถนนประเสริฐมนูญกิจ แขวงจรเข้บัว เขตลาดพร้าว",
        province: "Bangkok",
        province_th: "กรุงเทพมหานคร",
        postcode: "10230",
        phoneNumber: "02-502-7365",
        active: false,
        location_url:
            "https://www.google.co.th/maps/place/Villa+Market+-+Kaset+Nawamin/@13.8346122,100.6085085,17z/data=!3m1!4b1!4m5!3m4!1s0x30e29d652c26ea91:0xa6ac0e39d7f5e69b!8m2!3d13.8346122!4d100.6106972",
        code: "1022",
        online: true,
        hub: "1022",
    },
    {
        name: "Langsuan",
        name_th: "หลังสวน",
        distance: "3.0 km",
        latlng: [13.73968732, 100.54283023],
        address: "87 Soi Langsuan",
        subDistrict: "Lumpini",
        district: "Lumpini",
        address_th: "87 ซอย หลังสวน ลุมพินี",
        province: "Bangkok",
        province_th: "thailand",
        postcode: "10330",
        phoneNumber: "02-502-7383",
        active: false,
        location_url:
            "https://www.google.com/maps?ll=13.740567,100.543228&z=17&t=m&hl=en-US&gl=US&mapclient=apiv3&cid=1578456285860904640",
        code: "1049",
        online: true,
        hub: "1049",
    },
    {
        name: "Lasalle",
        name_th: "ลาซาล",
        distance: "3.0 km",
        latlng: [13.65756466, 100.624406],
        address: "549 Lasalle-Baring Road",
        subDistrict: "-",
        district: "Bangna",
        address_th: "549 ถนนลาซาล-แบริ่ง แขวงบางนาใต้  เขตบางนา",
        province: "thailand",
        province_th: "thailand",
        postcode: "10110",
        phoneNumber: "02-502-7381",
        active: false,
        location_url:
            "https://www.google.co.th/maps/place/Villa+Market+-+Lasalle's+Avenue/@13.6578966,100.6230417,18z/data=!4m12!1m6!3m5!1s0x311d5f3fb462c663:0x9be837cebfd1545f!2sVilla+Market+-+Lasalle's+Avenue!8m2!3d13.6577376!4d100.6241575!3m4!1s0x311d5f3fb462c663:0x9be837cebfd1545f!8m2!3d13.6577376!4d100.6241575?hl=th",
        code: "1047",
        online: true,
        hub: "1047",
    },
    {
        name: "Nichada",
        name_th: "นิชดา",
        distance: "3.0 km",
        latlng: [13.890849, 100.524473],
        address: "39/999 Moo 3",
        subDistrict: "Bangtalad",
        district: "Pakret",
        address_th: "39/999 หมู่ที่ 3 ตำบลบางตลาด อำเภอปากเกร็ด",
        province: "Nonthaburi",
        province_th: "นนทบุรี",
        postcode: "11120",
        phoneNumber: "02-502-7353",
        active: false,
        location_url:
            "https://www.google.co.th/maps/place/%E0%B8%A7%E0%B8%B4%E0%B8%A5%E0%B8%A5%E0%B9%88%E0%B8%B2%E0%B8%A1%E0%B8%B2%E0%B8%A3%E0%B9%8C%E0%B9%80%E0%B8%81%E0%B9%87%E0%B8%95%E0%B8%99%E0%B8%B4%E0%B8%8A%E0%B8%94%E0%B8%B2/@13.8928124,100.5221847,17z/data=!3m1!4b1!4m5!3m4!1s0x30e284a1670d4e17:0x2f739295269a6544!8m2!3d13.8928124!4d100.5243734",
        code: "1003",
        online: true,
        hub: "1003",
    },
    {
        name: "Paradise Park",
        name_th: "พาราไดซ์ พาร์ค",
        distance: "3.0 km",
        latlng: [13.688187, 100.647463],
        address: "61 Srinakarin Rd",
        subDistrict: "-",
        district: "Prawet",
        address_th: "61 ถนนศรีนครินทร์ แขวงหนองบอน เขตประเวศ",
        province: "Bangkok",
        province_th: "กรุงเทพมหานคร",
        postcode: "10250",
        phoneNumber: "02-502-7366",
        active: false,
        location_url:
            "https://www.google.co.th/maps/place/Villa+Market+-+Paradise+Park/@13.6887914,100.645757,17z/data=!3m1!4b1!4m5!3m4!1s0x311d607421ff91ed:0xad2040f971b9f07e!8m2!3d13.6887914!4d100.6479457",
        code: "1023",
        online: true,
        hub: "1023",
    },
    {
        name: "Paseo Kanchanapisek",
        name_th: "พาซิโอ กาญจนาภิเษก",
        distance: "3.0 km",
        latlng: [13.766491, 100.406783],
        address: "Paseo Town 8/9 Kanchanapisek Rd Sala Thammasop",
        subDistrict: "-",
        district: "-",
        address_th:
            "Paseo Town 8/9 ถนนกาญจนาภิเษก แขวงศาลาธรรมสพน์ เขตทวีวัฒนา",
        province: "Bangkok",
        province_th: "กรุงเทพมหานคร",
        postcode: "10170",
        phoneNumber: "02-502-7374",
        active: false,
        location_url:
            "https://www.google.co.th/maps/place/Villa+Market+-+Paseo+Kanchanaphisek/@13.7664422,100.4040096,17z/data=!3m1!4b1!4m5!3m4!1s0x30e2973cc51a1323:0xe95f8fd0bfaa0e1a!8m2!3d13.7664422!4d100.4061983",
        code: "1038",
        online: true,
        hub: "1038",
    },
    {
        name: "Paseo Lat Krabang",
        name_th: "พาซิโอ ลาดกระบัง",
        distance: "3.0 km",
        latlng: [13.720404, 100.726995],
        address: "318/5 Lat Krabang Rd Latkrabang",
        subDistrict: "-",
        district: "Klongsan",
        address_th: "318/5 ถนนลาดกระบัง แขวงลาดกระบัง เขตลาดกระบัง",
        province: "Bangkok",
        province_th: "กรุงเทพมหานคร",
        postcode: "10520",
        phoneNumber: "02-502-7372",
        active: false,
        location_url:
            "https://www.google.co.th/maps/place/Villa+Market+-+Paseo+Lat+Krabang/@13.720404,100.726995,17z/data=!3m1!4b1!4m5!3m4!1s0x311d672151917599:0x31b28ae0fab08254!8m2!3d13.7202583!4d100.7270386",
        code: "1034",
        online: true,
        hub: "1034",
    },
    {
        name: "Paseo Ramkamhaeng",
        name_th: "พาซิโอ รามคำแหง",
        distance: "3.0 km",
        latlng: [13.773988, 100.666877],
        address: "7/7  Ramkhamhaeng Rd Saphan Soong",
        subDistrict: "-",
        district: "-",
        address_th: "7/7 ถนนรามคำแหง แขวงสะพานสูง เขตสะพานสูง",
        province: "Bangkok ",
        province_th: "กรุงเทพมหานคร",
        postcode: "10240",
        phoneNumber: "02-502-7371",
        active: false,
        location_url:
            "https://www.google.co.th/maps/place/Villa+Market+-+Paseo+Ramkhamheang/@13.773988,100.6581223,15z/data=!4m8!1m2!2m1!1svilla+market+laguna!3m4!1s0x311d617fd08fca8f:0xea5c0d0f38cb8f88!8m2!3d13.773988!4d100.666877",
        code: "1033",
        online: true,
        hub: "1033",
    },
    {
        name: "Phaholyothin",
        name_th: "พหลโยธิน",
        distance: "3.0 km",
        latlng: [13.782999, 100.546467],
        address:
            "412/1 Phahonlyothin Place Building, Phaholyothin Rd., Samsean-nai, Payathai",
        subDistrict: "-",
        district: "-",
        address_th:
            "412/1 อาคารพหลโยธิน เพลส ถนนพหลโยธิน แขวงสามเสนใน เขตพญาไท",
        province: "Bangkok",
        province_th: " กรุงเทพมหานคร",
        postcode: "10400",
        phoneNumber: "02-502-7362",
        active: false,
        location_url:
            "https://www.google.com/maps/place/Villa+Market+-+Phahonyothin,+Samsean-Nai,+Phaya+Thai,+Bangkok/@13.7367735,100.6052704,15z/data=!4m5!3m4!1s0x30e29c1c2c1658ef:0x9bd7aa1378f1fd70!8m2!3d13.783269!4d100.5461768",
        code: "1019",
        online: true,
        hub: "1019",
    },
    {
        name: "Ploenchit",
        name_th: "เพลินจิต",
        distance: "3.0 km",
        latlng: [13.741798, 100.552366],
        address: "2 Sukumvit Rd. Klong Toei",
        subDistrict: "-",
        district: "-",
        address_th: "2 ซอยสุขุมวิท 2 (ซอยผาสุก) แขวงคลองเตย เขตคลองเตย",
        province: "Bangkok",
        province_th: "กรุงเทพมหานคร",
        postcode: "10110",
        phoneNumber: "02-502-7355",
        active: false,
        location_url:
            "https://www.google.co.th/maps/place/Villa+Market+-+Ploenchit/@13.7414779,100.5492709,17z/data=!3m1!4b1!4m5!3m4!1s0x30e29fbbf83ad793:0x5f49957d33d016e3!8m2!3d13.7414779!4d100.5514596",
        code: "1006",
        online: true,
        hub: "1006",
    },
    {
        name: "Rama 3",
        name_th: "พระราม 3",
        distance: "3.0 km",
        latlng: [13.700308, 100.540827],
        address: "54 Narathivasrachanakarin Rd Yannawa",
        subDistrict: "-",
        district: "-",
        address_th: "54 ถนนนราธิวาสราชนครินทร์ แขวงช่องนนทรี เขตยานนาวา",
        province: "Bangkok ",
        province_th: "กรุงเทพมหานคร",
        postcode: "10120",
        phoneNumber: "02-502-7373",
        active: false,
        location_url:
            "https://www.google.co.th/maps/place/Villa+Market+-+The+Up+Rama+3/@13.700308,100.5386383,17z/data=!3m1!4b1!4m5!3m4!1s0x30e29f4ff8ae5d7b:0xb30dea92480f9a06!8m2!3d13.700308!4d100.540827",
        code: "1036",
        online: true,
        hub: "1036",
    },
    {
        name: "Rama 9 (The Shoppes at Belle Grand)",
        name_th: "พระราม 9 (The Shoppes at Belle Grand)",
        distance: "3.0 km",
        latlng: [13.759806, 100.568542],
        address: "141/1 Rama 9 Rd Huaykwang ",
        subDistrict: "-",
        district: "-",
        address_th: "141/1 ถนนพระราม 9 แขวงห้วยขวาง เขตห้วยขวาง",
        province: "Bangkok",
        province_th: "กรุงเทพมหานคร",
        postcode: "10310",
        phoneNumber: "093-809-8025",
        active: false,
        location_url:
            "https://www.google.co.th/maps/place/Villa+Market+Belle+RamaIX/@13.7600924,100.5611477,15z/data=!4m8!1m2!2m1!1svilla+market+laguna!3m4!1s0x30e29e8b8cba69f7:0xb296212d51a752c9!8m2!3d13.7600924!4d100.5699024",
        code: "-",
        online: false,
        hub: "-",
    },
    {
        name: "Ramindra",
        name_th: "รามอินทรา",
        distance: "3.0 km",
        latlng: [13.856271, 100.629304],
        address: "248 Ramintra Rd Tharang,Bangkhaen",
        subDistrict: "-",
        district: "-",
        address_th: "248 ถนนรามอินทรา แขวงท่าแร้ง เขตบางเขน",
        province: "Bangkok",
        province_th: "กรุงเทพมหานคร",
        postcode: "10220",
        phoneNumber: "02-0331822",
        active: false,
        location_url:
            "https://www.google.co.th/maps/place/Villa+Market+-+Ramintra/@13.8560174,100.6270195,17z/data=!3m1!4b1!4m5!3m4!1s0x311d62af8aeeda5f:0x9032c23a316b1c9b!8m2!3d13.8560174!4d100.6292082",
        code: "-",
        online: false,
        hub: "-",
    },
    {
        name: "Ratchapreuk",
        name_th: "ราชพฤกษ์",
        distance: "3.0 km",
        latlng: [13.819943, 100.448484],
        address: "Home Pro 82  Moo 2 ,  Bangkhunkong, Bangkruay",
        subDistrict: "-",
        district: "-",
        address_th: "Home Pro 82 หมู่ที่ 2 ตำบลบางขุนกอง อำเภอบางกรวย",
        province: "Nonthaburi",
        province_th: "นนทบุรี",
        postcode: "11130",
        phoneNumber: "02-502-7363",
        active: false,
        location_url:
            "https://www.google.co.th/maps/place/Villa+Market+-+Ratchaphruek+(HomePro)/@13.819943,100.4462953,17z/data=!3m1!4b1!4m5!3m4!1s0x30e29a7af3ee10e5:0xefbb1e7f69fdea8e!8m2!3d13.819943!4d100.448484",
        code: "1020",
        online: true,
        hub: "1020",
    },
    {
        name: "Ratchayothin",
        name_th: "รัชโยธิน",
        distance: "3.0 km",
        latlng: [13.828584, 100.567104],
        address: "234 Ratchadapisek Rd. Jatujak",
        subDistrict: "-",
        district: "-",
        address_th: "234 ถนนรัชดาภิเษก แขวงลาดยาว เขตจตุจักร",
        province: " Bangkok",
        province_th: "กรุงเทพมหานคร",
        postcode: "10900",
        phoneNumber: "02-502-7362",
        active: false,
        location_url:
            "https://www.google.co.th/maps/place/Villa+market+%E0%B8%A3%E0%B8%B1%E0%B8%8A%E0%B9%82%E0%B8%A2%E0%B8%98%E0%B8%B4%E0%B8%99/@13.8278898,100.5653457,17z/data=!3m1!4b1!4m5!3m4!1s0x30e29cf9188fcddf:0x7be4071b3e7c68c1!8m2!3d13.8278898!4d100.5675344",
        code: "1019",
        online: true,
        hub: "1019",
    },
    {
        name: "Sammakorn",
        name_th: "สัมมากร",
        distance: "3.0 km",
        latlng: [13.776299, 100.673384],
        address: "86  Ramkhamhaeng Rd Saphan Soong",
        subDistrict: "-",
        district: "-",
        address_th: "86 ถนนรามคำแหง แขวงสะพานสูง เขตสะพานสูง",
        province: "Bangkok",
        province_th: "กรุงเทพมหานคร",
        postcode: "10240",
        phoneNumber: "02-502-7367",
        active: false,
        location_url:
            "https://www.google.co.th/maps/place/Villa+Market+-+Sammakorn/@13.7758222,100.6717033,17z/data=!3m1!4b1!4m5!3m4!1s0x311d63e8d8206473:0xe8e0926a924f1b22!8m2!3d13.7758222!4d100.673892",
        code: "1024",
        online: true,
        hub: "1024",
    },
    {
        name: "Sena Fest",
        name_th: "เสนาเฟสท์",
        distance: "3.0 km",
        latlng: [13.71921, 100.507704],
        address: "542,542/1-2 Charoennakorn Rd.",
        subDistrict: "-",
        district: "Klongsan",
        address_th: "542, 542/1-2 ถนนเจริญนคร แขวงคลองต้นสาย เขตคลองสาน",
        province: "Bangkok",
        province_th: "กรุงเทพมหานคร",
        postcode: "10600",
        phoneNumber: "02-502-7368",
        active: false,
        location_url:
            "https://www.google.co.th/maps/place/Villa+Market+-+Sena+Fest/@13.7194674,100.5051093,17z/data=!3m1!4b1!4m5!3m4!1s0x30e298c20e9ab507:0xbd971616b51f6d4a!8m2!3d13.7194674!4d100.507298",
        code: "1026",
        online: true,
        hub: "1026",
    },
    {
        name: "Silom",
        name_th: "สีลม",
        distance: "3.0 km",
        latlng: [13.723767, 100.531506],
        address: "425/129 Soi Sirijulasawake, Silom Rd., Bangkok",
        subDistrict: "-",
        district: "-",
        address_th: "425/129 ซอยศิริจุลเสวก ถนนสีลม แขวงสีลม เขตบางรัก",
        province: "Bangkok",
        province_th: "กรุงเทพมหานคร",
        postcode: "10500",
        phoneNumber: "02-502-7354",
        active: false,
        location_url:
            "https://www.google.co.th/maps/place/Villa+Market+Silom/@13.7414779,100.5492709,17z/data=!4m5!3m4!1s0x30e298d1f29e3887:0x7a723bc8da096619!8m2!3d13.724599!4d100.530886",
        code: "1007",
        online: true,
        hub: "1007",
    },
    {
        name: "Sukhumvit 11",
        name_th: "สุขุมวิท 11",
        distance: "3.0 km",
        latlng: [13.741172, 100.556418],
        address: "34 Soi Sukumvit 11(Chaiyos)  Sukhumvit Rd, Klongtoei Nua",
        subDistrict: "-",
        district: "-",
        address_th:
            "34 ซอยสุขุมวิท 11 (ชัยยศ) ถนนสุขุมวิท แขวงคลองเตยเหนือ เขตวัฒนา",
        province: "Bangkok",
        province_th: "กรุงเทพมหานคร",
        postcode: "10110",
        phoneNumber: "02-502-7380",
        active: false,
        location_url:
            "https://www.google.co.th/maps/place/Villa+Market+Ambrassy/@13.7451179,100.5539986,17z/data=!3m1!4b1!4m5!3m4!1s0x30e29e4db83a6971:0xec214d2303f78e97!8m2!3d13.7451179!4d100.5561873",
        code: "1046",
        online: true,
        hub: "1046",
    },
    {
        name: "Sukhumvit 49",
        name_th: "สุขุมวิท 49",
        distance: "3.0 km",
        latlng: [13.732509, 100.57628],
        address: "51/4 Soi Sukumvit 49, Sukumvit Rd., Klongtan Nua",
        subDistrict: "-",
        district: "-",
        address_th: "51/4 ซอยสุขุมวิท 49 ถนนสุขุมวิท แขวงคลองตันเหนือ",
        province: "Bangkok",
        province_th: "กรุงเทพมหานคร",
        postcode: "10110",
        phoneNumber: "02-502-7352",
        active: false,
        location_url:
            "https://www.google.co.th/maps/place/Villa+Market+-+Sukhumvit+49/@13.732509,100.5740913,17z/data=!3m1!4b1!4m5!3m4!1s0x30e29fa9f84c3679:0xa6b57eeb0fb0e0b8!8m2!3d13.732509!4d100.57628",
        code: "1005",
        online: true,
        hub: "1005",
    },
    {
        name: "ThongLor",
        name_th: "ทองหล่อ",
        distance: "3.0 km",
        latlng: [13.73457, 100.582001],
        address: "J-Avenue 323 Soi Sukumvit 55 (Thong Lo ), Klongtan Nua",
        subDistrict: "-",
        district: "-",
        address_th:
            "J-Avenue 323 ซอยสุขุมวิท 55 (ทองหล่อ) แขวงคลองตันเหนือ เขตวัฒนา",
        province: "Bangkok",
        province_th: " กรุงเทพมหานคร",
        postcode: "10110",
        phoneNumber: "02-502-7356",
        active: false,
        location_url:
            "https://www.google.co.th/maps/place/Villa+Market/@13.73457,100.5798123,17z/data=!3m1!4b1!4m5!3m4!1s0x30e29e5252a2d435:0xa6061cdd49cd5c90!8m2!3d13.73457!4d100.582001",
        code: "1011",
        online: true,
        hub: "1011",
    },
    {
        name: "The Circle",
        name_th: "เดอะเซอร์เคิล",
        distance: "3.0 km",
        latlng: [13.767211, 100.443864],
        address: "The Circle Shopping Mall 39 Ratchapruk Rd",
        subDistrict: "-",
        district: "Taling Chan ",
        address_th: "The Circle Shopping Mall 39 ถนนราชพฤกษ์ เขตตลิ่งชัน",
        province: "Bangkok",
        province_th: "กรุงเทพมหานคร",
        postcode: "10170",
        phoneNumber: "02-502-7377",
        active: false,
        location_url:
            "https://www.google.co.th/maps/place/Villa+Market+-+The+Circle+Ratchapruek/@13.7679919,100.4335306,15z/data=!4m8!1m2!2m1!1svilla+market+laguna!3m4!1s0x30e299e3d947517b:0x667ec6df5fc7f38e!8m2!3d13.7679919!4d100.4422853",
        code: "1041",
        online: true,
        hub: "1041",
    },
    {
        name: "Hua Hin",
        name_th: "หัวหิน",
        distance: "3.0 km",
        latlng: [12.564365, 99.959439],
        address: "218/1-4 Petchkasem Road",
        subDistrict: "-",
        district: "Hua Hin",
        address_th: "218/1-4 ถนนเพชรเกษม ตำบลหัวหิน อำเภอหัวหิน",
        province: " Prachuabkirikhan",
        province_th: "ประจวบคีรีขันธ์",
        postcode: "77110",
        phoneNumber: "02-502-7360",
        active: false,
        location_url:
            "https://www.google.co.th/maps/place/Villa+Market+-+Hua+Hin/@12.5818223,99.9374518,14z/data=!4m8!1m2!2m1!1zVmlsbGEgTWFya2V0IC0g4Lir4Lix4Lin4Lir4Li04LiZ!3m4!1s0x30fdabb04ed2ee8b:0xe92c7730e9db3c52!8m2!3d12.564365!4d99.959439",
        code: "1016",
        online: true,
        hub: "1016",
    },
    {
        name: "Index Hua Hin",
        name_th: "หัวหิน (Index)",
        distance: "3.0 km",
        latlng: [12.59948, 99.95025],
        address: "17/139 Soi Moo Baan Borfai",
        subDistrict: "-",
        district: "Hua Hin",
        address_th: "17/139 ถนนเพชรเกษม ตำบลหัวหิน อำเภอหัวหิน",
        province: "Prachuabkirikhan",
        province_th: "ประจวบคีรีขันธ์",
        postcode: "77110",
        phoneNumber: "02-502-7376",
        active: false,
        location_url:
            "https://www.google.co.th/maps/place/Villa+Market+-+Index+Hua+Hin/@12.5818245,99.9374518,14z/data=!4m8!1m2!2m1!1sVilla+Market+-+huahin!3m4!1s0x30fdaa6120ef7bbb:0x4e24ad935bb61f86!8m2!3d12.599327!4d99.95093",
        code: "1040",
        online: true,
        hub: "1040",
    },
    {
        name: "Pattaya",
        name_th: "พัทยา",
        distance: "3.0 km",
        latlng: [12.929871, 100.880805],
        address: "399/9 Moo 10",
        subDistrict: "Nongprue",
        district: "Banglamung",
        address_th: "399/9 หมู่ที่ 1 ตำบลหนองปรือ อำเภอบางละมุง",
        province: "Chonburi",
        province_th: "ชลบุรี",
        postcode: "20150",
        phoneNumber: "02-502-7359",
        active: false,
        location_url:
            "https://www.google.co.th/maps/place/Villa+Market+-+Pattaya,+Pattaya+City,+Chon+Buri/@13.7800514,100.5429267,17z/data=!4m5!3m4!1s0x3102960e432d57c3:0x810f83f58f04ad0b!8m2!3d12.929844!4d100.881132",
        code: "1015",
        online: true,
        hub: "1015",
    },
    {
        name: "Littlewalk Pattaya",
        name_th: "ลิดเติ้ลวอล์คพัทยา",
        distance: "3.0 km",
        latlng: [12.93627193, 100.9024377],
        address: "8/117 Moo 6",
        subDistrict: "Nongprue",
        district: "Banglamung",
        address_th:
            "8/117 หมู่ที่ 6  ต.หนองปรือ อ.บางละมุง  จังหวัดชลบุรี, 20150 ไทย",
        province: "Chonburi",
        province_th: "ชลบุรี",
        postcode: "20150",
        phoneNumber: "02-502-7382",
        active: false,
        location_url:
            "https://www.google.com/maps/place/Little+Walk+Pattaya/@12.937438,100.9002107,16.25z/data=!4m12!1m6!3m5!1s0x310295311844f539:0x8fa0b9ded1ffe1e9!2sLittle+Walk+Pattaya!8m2!3d12.9359595!4d100.9023308!3m4!1s0x310295311844f539:0x8fa0b9ded1ffe1e9!8m2!3d12.9359595!4d100.9023308",
        code: "1048",
        online: true,
        hub: "1048",
    },
    {
        name: "Chalong (Phuket)",
        name_th: "ฉลอง (ภูเก็ต)",
        distance: "3.0 km",
        latlng: [7.824785, 98.339117],
        address: "61/9 Moo 10",
        subDistrict: "-",
        district: "Mueangphuket",
        address_th: "61/9 หมู่ที่ 10 ตำบลฉลอง อำเภอเมือง",
        province: " Phuket  ",
        province_th: "ภูเก็ต",
        postcode: "83130",
        phoneNumber: "02-502-7364",
        active: false,
        location_url:
            "https://www.google.co.th/maps/place/Villa+Market+-+Chalong+Phuket/@7.824123,98.3374269,17z/data=!3m1!4b1!4m5!3m4!1s0x30502fbb764457eb:0x16ec17060183660c!8m2!3d7.824123!4d98.3396156",
        code: "1021",
        online: true,
        hub: "1021",
    },
    {
        name: "Laguna (Phuket)",
        name_th: "ลากูน่า (ภูเก็ต)",
        distance: "3.0 km",
        latlng: [7.993713, 98.30454],
        address: "49/13 Bandon-Cherngtalay Rd",
        subDistrict: "-",
        district: "Cherntalay Thalang",
        address_th: "49/13 ถนนบ้านดอน-เชิงทะเล ตำบลเชิงทะเล อำเภอถลาง",
        province: "Phuket",
        province_th: "ภูเก็ต",
        postcode: "83110",
        phoneNumber: "02-502-7370",
        active: false,
        location_url:
            "https://www.google.co.th/maps/place/Villa+Market+-+Boat+Avenue+Phuket+(Laguna)/@7.993803,98.302485,17z/data=!3m1!4b1!4m5!3m4!1s0x305039d9970c5de3:0x111ac795517a198!8m2!3d7.993803!4d98.3046737",
        code: "1032",
        online: true,
        hub: "1032",
    },
    {
        name: "Boat Lagoon (Phuket)",
        name_th: "โบ๊ทลากูน (ภูเก็ต)",
        distance: "3.0 km",
        latlng: [7.961894, 98.385269],
        address: "14/1 Moo 2 Thepkasattri Rd.",
        subDistrict: "Koh Kaew",
        district: "Muangphuket",
        address_th:
            "14/1 หมู่ที่ 2 ถนนเทพกษัตรี ตําบลเกาะแก้ว อําเภอเมืองภูเก็ต",
        province: "Phuket",
        province_th: "ภูเก็ต",
        postcode: "83000",
        phoneNumber: "02-502-7375",
        active: false,
        location_url:
            "https://www.google.co.th/maps/place/Villa+Market+-+Boat+Lagoon+Phuket/@7.9599974,98.3834987,17z/data=!3m1!4b1!4m5!3m4!1s0x305036b2abe84b1f:0x6a8f42affa27af26!8m2!3d7.9599974!4d98.3856874",
        code: "1039",
        online: true,
        hub: "1039",
    },
    {
        name: "UD Town Udon",
        name_th: "UD ทาวน์ อุดร ",
        distance: "3.0 km",
        latlng: [17.4007467, 102.8044618],
        address: "99/9 Thong Yai Road",
        subDistrict: "-",
        district: "Mueang Udonthani",
        address_th:
            "99/9 ถ.ทองใหญ่",
        province: "Udonthani",
        province_th: "อุดรธานี",
        postcode: "41000",
        phoneNumber: "02-502-7378",
        active: false,
        location_url:
            "https://www.google.com/maps/place/Villa+Market+-+Udonthani/@17.4007467,102.8044618,17z/data=!4m9!1m2!2m1!1svilla!3m5!1s0x31239d7e1b692f4d:0x49a9bbe5b99a7d05!8m2!3d17.3996703!4d102.8051323!15sCgV2aWxsYVoHIgV2aWxsYZIBC3N1cGVybWFya2V0",
        code: "1042",
        online: true,
        hub: "1042",
    },
    {
        name: "Bukis Phuket",
        name_th: "บูคิส ภูเก็ต",
        distance: "5.0 km",
        latlng: [7.893682729983237, 98.36844038650858],
        address: "89 moo 5, Tambon Wichit, Amphoe Mueang Phuket, Chang Wat Phuket 83000",
        subDistrict: "-",
        district: "-",
        address_th:
            "89 ม.5 ต.วิชิต อ.เมืองภูเก็ต ภูเก็ต 83000",
        province: "Phuket",
        province_th: "ภูเก็ต",
        postcode: "83000",
        phoneNumber: "0938098031",
        active: true,
        Location_url: "https://www.google.co.th/maps/place/Bukis+Phuket/@7.8934754,98.3673138,19z/data=!4m6!3m5!1s0x305031c6db0db945:0x20f75709fcf8ae31!8m2!3d7.8934754!4d98.3684081!15sCgVidWtpc1oHIgVidWtpc5IBBXN0b3Jl4AEA?hl=th&shorturl=1",
        code: "1050",
        online: true,
        hub: "1050",
    },
    {
        name: "Chic Republic",
        name_th: "ชิค รีพับบลิค ราชพฤกษ์",
        distance: "5.0 km",
        latlng: [13.90559334496285, 100.45011565100164],
        address: "6, 15 Moo.2 ratchapruck thumpon Om Kret, Pak Kret District, Nonthaburi 11120",
        subDistrict: "อ้อมเกร็ด",
        district: "ปากเกร็ด",
        address_th:
            "6, 15 Moo.2 ถนน ราชพฤกษ์ ตำบล อ้อมเกร็ด อำเภอปากเกร็ด นนทบุรี 11120",
        province: "Nonthaburi",
        province_th: "นนทบุรี",
        postcode: "11120",
        phoneNumber: "",
        active: true,
        Location_url: "https://www.google.co.th/maps/place/ชิค+รีพับบลิค+ราชพฤกษ์/@13.9052963,100.4456098,17z/data=!4m9!1m2!2m1!1schic+republic!3m5!1s0x30e29a72b3f75123:0x58edcf23d48aefc!8m2!3d13.9052913!4d100.4500949!15sCg1jaGljIHJlcHVibGljIgOIAQFaDyINY2hpYyByZXB1YmxpY5IBD2Z1cm5pdHVyZV9zdG9yZeABAA?hl=th",
        code: "1051",
        online: true,
        hub: "1051",
    },
    {
        name: "Littlewalk Lat-Krabang",
        name_th: "ลิตเติ้ลวอล์ค ลาดกระบัง",
        distance: "5.0 km",
        latlng: [13.722694893644737, 100.72588159746505],
        address: "597 Lat Krabang Road, Lat Krabang Subdistrict, Lat Krabang District, Bangkok 10520",
        subDistrict: "Lat Krabang",
        district: "Lat Krabang",
        address_th:
            "597 ถ.ลาดกระบัง แขวงลาดกระบัง เขตลาดกระบัง กรุงเทพ 10520",
        province: "Bangkok",
        province_th: "กรุงเทพฯ",
        postcode: "10520",
        phoneNumber: "025027387",
        active: true,
        location_url: "https://www.google.co.th/maps/place/Little+Walk+Ladkrabang/@13.7226063,100.7236929,17z/data=!4m12!1m6!3m5!1s0x311d67cf35b8fcb1:0xc0fe2511af4ebe4e!2sLittle+Walk+Ladkrabang!8m2!3d13.7226011!4d100.7258816!3m4!1s0x311d67cf35b8fcb1:0xc0fe2511af4ebe4e!8m2!3d13.7226011!4d100.7258816",
        code: "1052",
        online: true,
        hub: "1052",
    },
    {
        name: "Krungthep Kritha Littlewalk",
        name_th: "กรุงเทพกรีฑา ลิตเติ้ลวอล์ค",
        distance: "5.0 km",
        latlng: [13.752051517024789, 100.68596632944383],
        address: "36. Krungthep Kreetha 17/1 Srinakarin-Romklao Road, Thap Chang Subdistrict, Saphan Sung District, Bangkok 10250",
        subDistrict: "-",
        district: "-",
        address_th:
            "36.กรุงเทพกรีฑา 17/1 ถ.ศรีนครินทร์-ร่มเกล้า แขวงทับช้าง เขตสะพานสูง กรุงเทพ 10250",
        province: "Bangkok",
        province_th: "กรุงเทพมหานคร",
        postcode: "10250",
        phoneNumber: "02-5027388",
        active: true,
        location_url:
            "https://www.google.com/maps/place/Little+Walk+Krungthep+Kritha/@13.7519994,100.6833807,17z/data=!3m1!4b1!4m6!3m5!1s0x311d61bd6887f779:0xbe41d15e0d148d25!8m2!3d13.7519942!4d100.6859556!16s%2Fg%2F11sjrmtp4l?entry=ttu",
        code: "1053",
        online: true,
        hub: "1053",
    },
    {
        name: "Gaysorn Amarin",
        name_th: "เกษรอัมรินทร์",
        distance: "5.0 km",
        latlng: [13.744143789519272, 100.54138396909846],
        address: "496 502 Phloen Chit Rd, Lumphini, Pathum Wan, Bangkok 10330",
        subDistrict: "-",
        district: "-",
        address_th:
            "เลขที่ 496-502 อาคารเกษรอัมรินทร์ ถนนเพลินจิต แขวงลุมพินี เขตปทุมวัน กรุงเทพฯ 10330",
        province: "Bangkok",
        province_th: "กรุงเทพมหานคร",
        postcode: "10330",
        phoneNumber: "",
        active: true,
        location_url:"https://maps.app.goo.gl/CrWLroCM8BapheTB8",
        code: "1054",
        online: true,
        hub: "1054",
    },
    {
		name: "Nanglinchee",
		name_th: "นางลิ้นจี่",
		distance: "5.0 km",
		latlng: [
			13.712876897523904,
			100.54179075726094
		],
		address: "56 Nanglinchee Chong Nonsi, Yan Nawa, Bangkok 10120",
		subDistrict: "-",
		district: "-",
		address_th: "56 ถนน นางลิ้นจี่ Chong Nonsi, Yan Nawa, Bangkok 10120",
		province: "Bangkok",
		province_th: "กรุงเทพมหานคร",
		postcode: "10120",
		phoneNumber: "",
		active: true,
		location_url: "https://maps.app.goo.gl/Tw9gfdsYRMa3gkkM8",
		code: "1055",
		online: true,
		hub: "1055"
	},
    {
        name: "HomePro Cherngtalay",
        name_th: "โฮมโปรเชิงทะเล",
        distance: "5.0 km",
        latlng: [7.988426924582103, 98.3103385245848],
        address: "59 Srisunthon Rd., Chengtalay Subdistrict, Thalang District",
        subDistrict: "-",
        district: "-",
        address_th:
            "59 ถ. ศรีสุนทร ตำบลเชิงทะเล อำเภอถลาง",
        province: "Phuket",
        province_th: "ภูเก็ต",
        postcode: "83110",
        phoneNumber: "025027394",
        active: true,
        location_url: "https://maps.app.goo.gl/zvzAsN4XRAUGhLhn9",
        code: "1056",
        online: true,
        hub: "1056"
    },
    {
        name: "Kamala Phuket",
        name_th: "กมลา ภูเก็ต",
        distance: "5.0 km",
        latlng: [7.947008310314778, 98.27946320577146],
        address: "44 Kamala Subdistrict, Kathu District",
        subDistrict: "-",
        district: "-",
        address_th:
            "44 Kammala - Patong Rd, ตำบล กมลา อำเภอกะทู้",
        province: "Phuket",
        province_th: "ภูเก็ต",
        postcode: "83120",
        phoneNumber: "025057395",
        active: true,
        location_url: "https://maps.app.goo.gl/xxiyUkyJv6n7dpjs7",
        code: "1057",
        online: true,
        hub: "1057"
    },
    {
        name: "Kingsquare",
        name_th: "คิงสแควร์",
        distance: "5.0 km",
        latlng: [13.692053765661074, 100.52713124019922],
        address: "551 Soi Talat Sathonthip, Bang Phong Phang Subdistrict, Yannawa District, Bangkok 10120",
        subDistrict: "-",
        district: "-",
        address_th:
            "551 ซอย ตลาดศธรทิพย์ แขวงบางโพงพาง เขตยานนาวา กรุงเทพมหานคร 10120",
        province: "Bangkok",
        province_th: "กรุงเทพมหานคร",
        postcode: "10120",
        phoneNumber: "",
        active: true,
        location_url:"https://maps.app.goo.gl/MWgG8g4GU1EQWiU17",
        code: "1059",
        online: true,
        hub: "1059",
    },
    {
        name: "Little Walk Rattanathibet",
        name_th: "ลิตเติ้ลวอล์ค รัตนาธิเบศร์",
        distance: "5.0 km",
        latlng: [
            13.865245997435057,
            100.49461419839213
        ],
        address: "371 Rattanathibet Road, Bang Krasor, Mueang Nonthaburi District, Nonthaburi 11000",
        subDistrict: "-",
        district: "-",
        address_th: "371 ถนน รัตนาธิเบศร์ บางกระสอ อำเภอเมืองนนทบุรี นนทบุรี 11000",
        province: "Nonthaburi",
        province_th: "นนทบุรี",
        postcode: "11000",
        phoneNumber: "",
        active: true,
        location_url: "https://maps.app.goo.gl/aqs5R7XGVhx2YrXA7",
        code: "1058",
        online: true,
        hub: "1058"
    }
];


export function mini() {
    return branchs
        .filter((i) => i.online)
        .map((i) => {
            return {
                name: i.name,
                code: i.code,
            };
        });
}

export function online() {
    return branchs.filter((i) => i.online);
}

export function getBranch(brcode) {
    return branchs.find((branch) => branch.code === brcode);
}

export function getBranchAddress(name) {
    return branchs.find((item) => item.name === name);
}

export default branchs;